import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        height: 52,
        paddingHorizontal: 16,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    titleContainer: {
        flex: 1,
    },
    title: {
        color: COLOR.WHITE_OVERLAY(0.7),
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        lineHeight: 20,
        letterSpacing: 0.08,
    },
    selectedTitle: {
        color: COLOR.background,
        fontFamily: Fonts.main.bold,
        fontSize: 16,
    },
    checkMark: {
        opacity: 0,
        marginLeft: 16,
    },
    checkMarkVisisble: {
        opacity: 1,
    },
    selectedItem: {
        backgroundColor: COLOR.primary,
    },
});

export default styles;
